// import React, { useEffect, useState } from "react";
// import DatePicker from "react-datepicker";
// import "react-datepicker/dist/react-datepicker.css";
// import Navbar from "../common/Navbar";
// import Sidebar from "../common/Sidebar";
// import Footer from "../common/Footer";
// import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
// import {
//   faClock,
//   faUser,
//   faEnvelope,
//   faCalendarAlt,
//   faTasks,
//   faSearch,
//   faSyncAlt,
//   faExclamationCircle,
//   faChevronLeft,
//   faChevronRight,
// } from "@fortawesome/free-solid-svg-icons";
// import "./TimesheetAccess.css";

// const BASE_URL = process.env.REACT_APP_BASE_URL;

// const TimesheetAccess = () => {
//   const [timesheets, setTimesheets] = useState([]);
//   const [employees, setEmployees] = useState([]);
//   const [error, setError] = useState("");
//   const [loading, setLoading] = useState(true);
//   const [isSidebarOpen, setIsSidebarOpen] = useState(false);
//   const [pagination, setPagination] = useState({
//     total: 0,
//     totalPages: 1,
//     currentPage: 1,
//     limit: 10,
//     hasNextPage: false,
//     hasPreviousPage: false,
//   });
//   const [currentPageTotals, setCurrentPageTotals] = useState({
//     hours: 0,
//     members: 0,
//   });
//   const [allDataTotals, setAllDataTotals] = useState({
//     entries: 0,
//   });

//   const [filters, setFilters] = useState({
//     employeeId: "",
//     date: null,
//   });

//   // Fetch all employees for the dropdown
//   const fetchEmployees = async () => {
//     try {
//       const token = sessionStorage.getItem("token");
//       if (!token) {
//         setError("No token found. Please log in.");
//         return;
//       }

//       const response = await fetch(`${BASE_URL}/api/employees/`, {
//         method: "GET",
//         headers: {
//           Authorization: `Bearer ${token}`,
//           "Content-Type": "application/json",
//         },
//       });

//       if (!response.ok) {
//         const data = await response.json();
//         throw new Error(data.msg || "Error fetching employees");
//       }

//       const data = await response.json();
//       setEmployees(data);
//     } catch (err) {
//       console.error("Error fetching employees:", err);
//       setError(err.message || "Error fetching employees");
//     }
//   };

//   const fetchTimesheets = async (page = 1, filters = {}) => {
//     try {
//       setLoading(true);
//       const token = sessionStorage.getItem("token");
//       if (!token) {
//         setError("No token found. Please log in.");
//         return;
//       }

//       let url = `${BASE_URL}/api/timesheet/logined/getSubordinateTimesheets?page=${page}`;

//       // Add filters to URL if they exist
//       if (filters.employeeId) {
//         url += `&employeeId=${encodeURIComponent(filters.employeeId)}`;
//       }
//       if (filters.date) {
//         url += `&date=${filters.date.toISOString()}`;
//       }

//       const response = await fetch(url, {
//         method: "GET",
//         headers: {
//           Authorization: `Bearer ${token}`,
//           "Content-Type": "application/json",
//         },
//       });

//       if (!response.ok) {
//         const data = await response.json();
//         throw new Error(data.msg || "Error fetching timesheets");
//       }

//       const data = await response.json();
//       setTimesheets(data.timesheets);
//       setCurrentPageTotals(data.currentPageTotals);
//       setAllDataTotals(data.allDataTotals);
//       setPagination(data.pagination);
//       setError("");
//     } catch (err) {
//       console.error("Error fetching timesheets:", err);
//       setError(err.message || "Error fetching timesheets");
//     } finally {
//       setLoading(false);
//     }
//   };

//   useEffect(() => {
//     fetchEmployees();
//     fetchTimesheets(1);
//   }, []);

//   const handlePageChange = (newPage) => {
//     if (newPage < 1 || newPage > pagination.totalPages) return;
//     fetchTimesheets(newPage, filters);
//   };

//   const handleFilterChange = (e) => {
//     const { name, value } = e.target;
//     setFilters((prev) => ({
//       ...prev,
//       [name]: value,
//     }));
//   };

//   const handleDateChange = (date) => {
//     setFilters((prev) => ({
//       ...prev,
//       date,
//     }));
//   };

//   const applyFilters = () => {
//     fetchTimesheets(1, filters);
//   };

//   const clearFilters = () => {
//     setFilters({
//       employeeId: "",
//       date: null,
//     });
//     fetchTimesheets(1, {});
//   };

//   const formatDate = (dateString) => {
//     const date = new Date(dateString);
//     return date.toLocaleDateString("en-US", {
//       weekday: "short",
//       month: "short",
//       day: "numeric",
//       year: "numeric",
//     });
//   };

//   const toggleSidebar = () => {
//     setIsSidebarOpen(!isSidebarOpen);
//   };

//   const handleRetry = () => {
//     setError("");
//     setLoading(true);
//     fetchTimesheets(1, filters);
//   };

//   return (
//     <div
//       className={`timesheet-access-page ${isSidebarOpen ? "sidebar-open" : ""}`}
//     >
//       <Navbar toggleSidebar={toggleSidebar} />
//       <Sidebar isOpen={isSidebarOpen} toggleSidebar={toggleSidebar} />

//       <div className="timesheet-container">
//         <div className="timesheet-header">
//           <div className="header-content">
//             <p className="description-text">
//               Review and manage your team's timesheet entries
//             </p>
//           </div>

//           <div className="filters-container">
//             <div className="filter-group">
//               <label htmlFor="employeeId">Employee</label>
//               <select
//                 id="employeeId"
//                 name="employeeId"
//                 value={filters.employeeId}
//                 onChange={handleFilterChange}
//               >
//                 <option value="">All Employees</option>
//                 {employees.map((employee) => (
//                   <option key={employee._id} value={employee.employeeid}>
//                     {employee.name} ({employee.employeeid})
//                   </option>
//                 ))}
//               </select>
//             </div>

//             <div className="filter-group">
//               <label htmlFor="date">Date</label>
//               <DatePicker
//                 selected={filters.date}
//                 onChange={handleDateChange}
//                 dateFormat="yyyy-MM-dd"
//                 placeholderText="Filter by date..."
//                 isClearable
//               />
//             </div>

//             <div className="filter-actions">
//               <button
//                 className="apply-filters"
//                 onClick={applyFilters}
//                 disabled={loading}
//               >
//                 Apply Filters
//               </button>
//               <button
//                 className="clear-filters"
//                 onClick={clearFilters}
//                 disabled={loading}
//               >
//                 Clear Filters
//               </button>
//             </div>
//           </div>
//         </div>

//         {loading ? (
//           <div className="loading-container">
//             <div className="loading-spinner">
//               <FontAwesomeIcon icon={faSyncAlt} spin />
//             </div>
//             <p>Loading timesheets...</p>
//           </div>
//         ) : error ? (
//           <div className="error-container">
//             <FontAwesomeIcon
//               icon={faExclamationCircle}
//               className="error-icon"
//             />
//             <p className="error-message">{error}</p>
//             <button onClick={handleRetry} className="retry-button">
//               <FontAwesomeIcon icon={faSyncAlt} /> Retry
//             </button>
//           </div>
//         ) : (
//           <>
//             {timesheets.length === 0 ? (
//               <div className="no-results">
//                 <img
//                   src="/images/no-data.svg"
//                   alt="No results found"
//                   className="no-results-image"
//                 />
//                 <h3>No timesheets found</h3>
//                 <p>Try adjusting your filters or check back later</p>
//                 {(filters.employeeId || filters.date) && (
//                   <button
//                     className="clear-search-button"
//                     onClick={clearFilters}
//                   >
//                     Clear filters
//                   </button>
//                 )}
//               </div>
//             ) : (
//               <div className="timesheet-content">
//                 <div className="summary-cards">
//                   <div className="summary-card">
//                     <div className="card-value">{allDataTotals.entries}</div>
//                     <div className="card-label">Total Entries</div>
//                   </div>
//                   <div className="summary-card">
//                     <div className="card-value">{currentPageTotals.hours}</div>
//                     <div className="card-label">Page Hours</div>
//                   </div>
//                   <div className="summary-card">
//                     <div className="card-value">
//                       {currentPageTotals.members}
//                     </div>
//                     <div className="card-label">Page Members</div>
//                   </div>
//                 </div>

//                 <div className="timesheet-table-container">
//                   <table className="timesheet-table">
//                     <thead>
//                       <tr>
//                         <th>
//                           <FontAwesomeIcon icon={faCalendarAlt} /> Date
//                         </th>
//                         <th>
//                           <FontAwesomeIcon icon={faUser} /> Employee
//                         </th>
//                         <th>
//                           <FontAwesomeIcon icon={faEnvelope} /> Email
//                         </th>
//                         <th>
//                           <FontAwesomeIcon icon={faTasks} /> Tasks
//                         </th>
//                       </tr>
//                     </thead>
//                     <tbody>
//                       {timesheets.map((timesheet) => (
//                         <tr key={timesheet._id}>
//                           <td data-label="Date">
//                             <div className="date-cell">
//                               {formatDate(timesheet.date)}
//                             </div>
//                           </td>
//                           <td data-label="Employee">
//                             <div className="employee-cell">
//                               <div className="avatar">
//                                 {timesheet.userId?.name?.charAt(0) || "U"}
//                               </div>
//                               <div className="employee-info">
//                                 <div className="employee-name">
//                                   {timesheet.userId?.name || "N/A"}
//                                 </div>
//                                 <div className="employee-position">
//                                   {timesheet.userId?.position || "Team Member"}
//                                 </div>
//                               </div>
//                             </div>
//                           </td>
//                           <td data-label="Email">
//                             <div className="email-cell">
//                               <a
//                                 href={`mailto:${timesheet.userId?.email || ""}`}
//                               >
//                                 {timesheet.userId?.email || "N/A"}
//                               </a>
//                             </div>
//                           </td>
//                           <td data-label="Tasks">
//                             <div className="task-list">
//                               {timesheet.taskDetails.map((task, index) => (
//                                 <div key={index} className="task-item">
//                                   <span className="task-name">
//                                     {task.taskName}
//                                   </span>
//                                   <span className="task-duration">
//                                     {task.duration} hrs
//                                   </span>
//                                 </div>
//                               ))}
//                             </div>
//                           </td>
//                         </tr>
//                       ))}
//                     </tbody>
//                   </table>

//                   {/* Mobile Cards */}
//                   <div className="timesheet-cards">
//                     {timesheets.map((timesheet) => (
//                       <div key={timesheet._id} className="timesheet-card">
//                         <div className="card-header">
//                           <div className="date">
//                             {formatDate(timesheet.date)}
//                           </div>
//                           <div className="hours">
//                             {timesheet.hoursWorked} hours
//                           </div>
//                         </div>
//                         <div className="card-body">
//                           <div className="employee-info">
//                             <div className="avatar">
//                               {timesheet.userId?.name?.charAt(0) || "U"}
//                             </div>
//                             <div className="details">
//                               <div className="name">
//                                 {timesheet.userId?.name || "N/A"}
//                               </div>
//                               <div className="email">
//                                 <a
//                                   href={`mailto:${
//                                     timesheet.userId?.email || ""
//                                   }`}
//                                 >
//                                   {timesheet.userId?.email || "N/A"}
//                                 </a>
//                               </div>
//                             </div>
//                           </div>
//                           <div className="tasks-section">
//                             <div className="section-title">
//                               <FontAwesomeIcon icon={faTasks} /> Tasks
//                             </div>
//                             <div className="task-list">
//                               {timesheet.taskDetails.map((task, index) => (
//                                 <div key={index} className="task-item">
//                                   <span className="task-name">
//                                     {task.taskName}
//                                   </span>
//                                   <span className="task-duration">
//                                     {task.duration} hrs
//                                   </span>
//                                 </div>
//                               ))}
//                             </div>
//                           </div>
//                         </div>
//                       </div>
//                     ))}
//                   </div>

//                   {/* Pagination Controls */}
//                   <div className="pagination-controls">
//                     <button
//                       onClick={() =>
//                         handlePageChange(pagination.currentPage - 1)
//                       }
//                       disabled={!pagination.hasPreviousPage || loading}
//                       className="pagination-button"
//                     >
//                       <FontAwesomeIcon icon={faChevronLeft} />
//                       Previous
//                     </button>

//                     <div className="page-info">
//                       Page {pagination.currentPage} of {pagination.totalPages}
//                     </div>

//                     <button
//                       onClick={() =>
//                         handlePageChange(pagination.currentPage + 1)
//                       }
//                       disabled={!pagination.hasNextPage || loading}
//                       className="pagination-button"
//                     >
//                       Next
//                       <FontAwesomeIcon icon={faChevronRight} />
//                     </button>
//                   </div>
//                 </div>
//               </div>
//             )}
//           </>
//         )}
//       </div>

//       <Footer />
//     </div>
//   );
// };

// export default TimesheetAccess;












import React, { useEffect, useState } from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import Navbar from "../common/Navbar";
import Sidebar from "../common/Sidebar";
import Footer from "../common/Footer";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faClock,
  faUser,
  faEnvelope,
  faCalendarAlt,
  faTasks,
  faSearch,
  faSyncAlt,
  faExclamationCircle,
  faChevronLeft,
  faFilter,
  faChevronRight,
} from "@fortawesome/free-solid-svg-icons";
import { faCheck, faTimes } from '@fortawesome/free-solid-svg-icons';

import {
  styled,
  Box,
  Typography,
  Select,
  MenuItem,
  Button,
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  Paper,
  Card,
  CardContent,
  Grid,
  Avatar,
  Link,
  CircularProgress,
  useMediaQuery,
  useTheme
} from '@mui/material';
import {
  TextField,
  InputAdornment,
} from "@mui/material";
import FilterListIcon from '@mui/icons-material/FilterList';
import CalendarTodayIcon from '@mui/icons-material/CalendarToday';
import FormatListNumberedIcon from '@mui/icons-material/FormatListNumbered';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import PeopleAltIcon from '@mui/icons-material/PeopleAlt';
// 🧠 At the top of your file, make sure to import:
// import { useMediaQuery } from "@mui/material";

// const theme = useTheme();
// const isMobile = useMediaQuery(theme.breakpoints.down("sm"));



const BASE_URL = process.env.REACT_APP_BASE_URL;

const normalizeFilterDate = (date) => {
  if (!date) return null;
  return new Date(date.getFullYear(), date.getMonth(), date.getDate());
};

const formatDateForApi = (date) => {
  if (!date) return "";
  const y = date.getFullYear();
  const m = String(date.getMonth() + 1).padStart(2, "0");
  const d = String(date.getDate()).padStart(2, "0");
  return `${y}-${m}-${d}`;
};

// Styled components
const TimesheetContainer = styled(Box)(({ theme }) => ({
  flex: 1,
  padding: theme.spacing(4),
  maxWidth: 1400,
  margin: '0 auto',
  width: '85%',
  marginLeft: 240,
  transition: theme.transitions.create('all', {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  [theme.breakpoints.down('lg')]: {
    width: '100%',
    marginLeft: 0,
    padding: theme.spacing(2),
  },
}));

const SummaryCard = styled(Card)(({ theme }) => ({
  borderRadius: 10,
  padding: theme.spacing(3),
  boxShadow: theme.shadows[1],
  textAlign: 'center',
  transition: theme.transitions.create(['transform', 'box-shadow'], {
    duration: theme.transitions.duration.short,
  }),
  '&:hover': {
    transform: 'translateY(-3px)',
    boxShadow: theme.shadows[4],
  },
}));

const CardValue = styled(Typography)(({ theme }) => ({
  fontSize: '2rem',
  fontWeight: 600,
  color: theme.palette.text.primary,
  marginBottom: theme.spacing(0.5),
}));

const CardLabel = styled(Typography)(({ theme }) => ({
  fontSize: '0.9rem',
  color: theme.palette.text.secondary,
  textTransform: 'uppercase',
  letterSpacing: 0.5,
}));

const StyledTable = styled(Table)(({ theme }) => ({
  width: '100%',
  borderCollapse: 'collapse',
  [theme.breakpoints.down('lg')]: {
    display: 'none',
  },
}));

const StyledTableHead = styled(TableHead)(({ theme }) => ({
  backgroundColor: theme.palette.primary.main,
}));

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  padding: theme.spacing(2),
  borderBottom: `1px solid ${theme.palette.divider}`,
  verticalAlign: 'top',
}));

const StyledTableHeaderCell = styled(StyledTableCell)(({ theme }) => ({
  color: theme.palette.common.white,
  fontWeight: 500,
  fontSize: '0.9rem',
  textTransform: 'uppercase',
  letterSpacing: 0.5,
}));

const TimesheetCardsContainer = styled(Box)(({ theme }) => ({
  display: 'none',
  flexDirection: 'column',
  gap: theme.spacing(2),
  padding: theme.spacing(2),
  [theme.breakpoints.down('lg')]: {
    display: 'flex',
  },
}));

const TimesheetCard = styled(Paper)(({ theme }) => ({
  borderRadius: 8,
  boxShadow: theme.shadows[1],
  overflow: 'hidden',
  transition: theme.transitions.create('box-shadow', {
    duration: theme.transitions.duration.short,
  }),
  '&:hover': {
    boxShadow: theme.shadows[4],
  },
}));

const CardHeader = styled(Box)(({ theme }) => ({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  padding: theme.spacing(2),
  backgroundColor: theme.palette.grey[100],
  borderBottom: `1px solid ${theme.palette.divider}`,
}));

const CardBody = styled(Box)(({ theme }) => ({
  padding: theme.spacing(2),
}));

const TaskItem = styled(Box)(({ theme }) => ({
  display: 'flex',
  justifyContent: 'space-between',
  fontSize: '0.9rem',
  [theme.breakpoints.down('sm')]: {
    flexDirection: 'column',
    gap: theme.spacing(0.5),
  },
}));

const FiltersContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexWrap: 'wrap',
  gap: theme.spacing(2),
  marginTop: theme.spacing(3),
}));

const FilterGroup = styled(Box)(({ theme }) => ({
  flex: 1,
  minWidth: 200,
}));

const FilterActions = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'flex-end',
  gap: theme.spacing(1.5),
  flexShrink: 0,
}));

const TimesheetFiltersBar = styled(Paper)(({ theme }) => ({
  padding: theme.spacing(2, 2.5),
  borderRadius: 16,
  border: '1px solid #eef0f6',
  boxShadow: '0 2px 12px rgba(15, 23, 42, 0.06)',
  backgroundColor: '#fff',
  marginBottom: theme.spacing(2.5),
  marginTop: theme.spacing(2),
}));

const TimesheetFilterField = styled(Box)(() => ({
  display: 'flex',
  flexDirection: 'column',
  gap: 6,
  minWidth: 0,
}));

const TimesheetFilterLabel = styled(Typography)(() => ({
  fontSize: '0.75rem',
  fontWeight: 600,
  color: '#5a5f7a',
  textTransform: 'uppercase',
  letterSpacing: '0.04em',
  lineHeight: 1.2,
}));

const TimesheetFilterControl = styled(Box)(() => ({
  display: 'flex',
  alignItems: 'center',
  gap: 8,
  height: 40,
  padding: '0 12px',
  borderRadius: 10,
  border: '1px solid #e2e8f0',
  backgroundColor: '#f8fafc',
  transition: 'border-color 0.2s ease, box-shadow 0.2s ease',
  '&:focus-within': {
    borderColor: '#667eea',
    boxShadow: '0 0 0 3px rgba(102, 126, 234, 0.12)',
    backgroundColor: '#fff',
  },
}));

const TimesheetFiltersGrid = styled(Box)(({ theme }) => ({
  display: 'grid',
  gridTemplateColumns: 'minmax(220px, 1fr) 172px auto',
  columnGap: theme.spacing(2),
  rowGap: theme.spacing(2),
  alignItems: 'end',
  width: '100%',
  [theme.breakpoints.down('md')]: {
    gridTemplateColumns: '1fr',
  },
}));

const TimesheetEmployeeFilterField = styled(TimesheetFilterField)(() => ({
  minWidth: 0,
  width: '100%',
}));

const TimesheetDateFilterField = styled(TimesheetFilterField)(() => ({
  width: 172,
  maxWidth: 172,
  flexShrink: 0,
  justifySelf: 'start',
}));

const TimesheetDateFilterControl = styled(TimesheetFilterControl)(() => ({
  width: '100%',
  maxWidth: 172,
  boxSizing: 'border-box',
  overflow: 'hidden',
}));

const TimesheetFilterActionsSlot = styled(FilterActions)(({ theme }) => ({
  flexShrink: 0,
  justifySelf: 'end',
  whiteSpace: 'nowrap',
  [theme.breakpoints.down('md')]: {
    justifySelf: 'stretch',
    justifyContent: 'flex-end',
  },
}));

const LoadingContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  padding: theme.spacing(6),
  textAlign: 'center',
}));

const ErrorContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  padding: theme.spacing(6),
  textAlign: 'center',
  color: theme.palette.error.main,
}));

const NoResultsContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  padding: theme.spacing(6),
  textAlign: 'center',
}));

const EmployeeCell = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: theme.spacing(1),
}));

const EmployeeInfo = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
}));

const TaskList = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(1),
}));

const PaginationControls = styled(Box)(({ theme }) => ({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  gap: theme.spacing(2),
  padding: theme.spacing(2),
}));

const TimesheetAccess = () => {
  const [timesheets, setTimesheets] = useState([]);
  const [employees, setEmployees] = useState([]);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(true);
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const [pagination, setPagination] = useState({
    total: 0,
    totalPages: 1,
    currentPage: 1,
    limit: 10,
    hasNextPage: false,
    hasPreviousPage: false,
  });
  const [currentPageTotals, setCurrentPageTotals] = useState({
    hours: 0,
    members: 0,
  });
  const [allDataTotals, setAllDataTotals] = useState({
    entries: 0,
  });
  const [filters, setFilters] = useState({
    employeeId: "",
    date: null,
  });

  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('lg'));

  // Fetch all employees for the dropdown
  const fetchEmployees = async () => {
    try {
      const token = sessionStorage.getItem("token");
      if (!token) {
        setError("No token found. Please log in.");
        return;
      }

      const response = await fetch(`${BASE_URL}/api/employees/`, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      });

      if (!response.ok) {
        const data = await response.json();
        throw new Error(data.msg || "Error fetching employees");
      }

      const data = await response.json();
      setEmployees(data);
    } catch (err) {
      console.error("Error fetching employees:", err);
      setError(err.message || "Error fetching employees");
    }
  };

  const fetchTimesheets = async (page = 1, filters = {}) => {
    try {
      setLoading(true);
      const token = sessionStorage.getItem("token");
      if (!token) {
        setError("No token found. Please log in.");
        return;
      }

      let url = `${BASE_URL}/api/timesheet/logined/getSubordinateTimesheets?page=${page}`;

      // Add filters to URL if they exist
      if (filters.employeeId) {
        url += `&employeeId=${encodeURIComponent(filters.employeeId)}`;
      }
      if (filters.date) {
        url += `&date=${formatDateForApi(filters.date)}`;
      }

      const response = await fetch(url, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      });

      if (!response.ok) {
        const data = await response.json();
        throw new Error(data.msg || "Error fetching timesheets");
      }

      const data = await response.json();
      setTimesheets(data.timesheets);
      setCurrentPageTotals(data.currentPageTotals);
      setAllDataTotals(data.allDataTotals);
      setPagination(data.pagination);
      setError("");
    } catch (err) {
      console.error("Error fetching timesheets:", err);
      setError(err.message || "Error fetching timesheets");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchEmployees();
    fetchTimesheets(1);
  }, []);

  const handlePageChange = (newPage) => {
    if (newPage < 1 || newPage > pagination.totalPages) return;
    fetchTimesheets(newPage, filters);
  };

  const handleFilterChange = (e) => {
    const { name, value } = e.target;
    setFilters((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleDateChange = (date) => {
    setFilters((prev) => ({
      ...prev,
      date: normalizeFilterDate(date),
    }));
  };

  const applyFilters = () => {
    fetchTimesheets(1, filters);
  };

  const clearFilters = () => {
    setFilters({
      employeeId: "",
      date: null,
    });
    fetchTimesheets(1, {});
  };

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleDateString("en-US", {
      weekday: "short",
      month: "short",
      day: "numeric",
      year: "numeric",
    });
  };

  const toggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen);
  };

  const handleRetry = () => {
    setError("");
    setLoading(true);
    fetchTimesheets(1, filters);
  };

  return (
    // <Box
    //   sx={{
    //     // marginLeft: '5px',
    //     // marginRight: '7px',
    //     // mt: '30px',
    //     paddingLeft: isSidebarOpen ? { xs: 0, lg: '250px' } : 0,
    //     transition: theme.transitions.create('padding-left', {
    //       easing: theme.transitions.easing.sharp,
    //       duration: theme.transitions.duration.leavingScreen,
    //     }),
    //     position: 'relative',
    //     overflowX: 'hidden', // prevents right overflow
    //     // maxWidth: '100vw',   // ensures container never exceeds viewport
    //     fontSize: '0.92rem',
    //   }}
    // >

    //   <Navbar toggleSidebar={toggleSidebar} />
    //   <Sidebar isOpen={isSidebarOpen} toggleSidebar={toggleSidebar} />
    //   <TimesheetContainer
    //     sx={{
    //       padding: { xs: '7px', sm: '24px', md: '32px' },
    //       transform: 'none', // remove shifting
    //       transformOrigin: 'top left',
    //       // marginRight:'10px',
    //       scale: 0.98,
    //     }}
    //   >

    //     <Box
    //       sx={{
    //         display: "flex",
    //         justifyContent: "space-between",
    //         alignItems: "center",
    //         flexWrap: "wrap",
    //         rowGap: 2,
    //         mb: 1,
    //         mt: 3,
    //       }}
    //     >
    //       {/* Left side: Title and Subtitle */}
    //       <Box sx={{ marginBottom: 3, mt: 6 }}>
    //         <Typography variant="h4" fontWeight="bold" gutterBottom>
    //           <FontAwesomeIcon icon={faClock} /> Timesheet Access
    //         </Typography>
    //         <Typography variant="subtitle1" color="text.secondary" >
    //           Review and manage your team's timesheet entries
    //         </Typography>
    //       </Box>

    //       {/* Right side: Search + Filter */}
    //       <FiltersContainer
    //         sx={{
    //           display: 'flex',
    //           flexWrap: 'wrap',
    //           gap: 1.5,
    //           mb: 2,
    //           alignItems: 'flex-end',
    //         }}
    //       >

    //         <Box
    //           sx={{
    //             display: "flex",
    //             alignItems: "center",
    //             backgroundColor: "#fff",
    //             border: "1px solid #ccc",
    //             borderRadius: "6px",
    //             height: 38,
    //             width: 300,
    //             px: 1.5,
    //             boxShadow: "0px 1px 3px rgba(0, 0, 0, 0.05)",
    //             overflow: "hidden",
    //           }}
    //         >
    //           <FontAwesomeIcon
    //             icon={faFilter}
    //             style={{ color: "#A0A4A8", marginRight: 8, fontSize: 14 }}
    //           />

    //           <Select
    //             id="employeeId"
    //             name="employeeId"
    //             value={filters.employeeId}
    //             onChange={handleFilterChange}
    //             displayEmpty
    //             fullWidth
    //             variant="standard"
    //             disableUnderline
    //             size="small"
    //             MenuProps={{
    //               PaperProps: {
    //                 sx: {
    //                   borderRadius: 2,
    //                   mt: 1,
    //                 },
    //               },
    //             }}
    //             sx={{
    //               fontSize: 14,
    //               color: "#7f8c8d",
    //               pl: 0.5,
    //               "&:focus": {
    //                 backgroundColor: "transparent",
    //               },
    //               "& .MuiSelect-select": {
    //                 display: "flex",
    //                 alignItems: "center",
    //                 paddingTop: 0,
    //                 paddingBottom: 0,
    //                 height: "100%",
    //               },
    //             }}
    //           >
    //             <MenuItem value="" disabled>
    //               All Employees
    //             </MenuItem>
    //             {employees.map((employee) => (
    //               <MenuItem key={employee._id} value={employee.employeeid}>
    //                 {employee.name} ({employee.employeeid})
    //               </MenuItem>
    //             ))}
    //           </Select>
    //         </Box>




    //         <Box
    //           sx={{
    //             display: "flex",
    //             alignItems: "center",
    //             backgroundColor: "#fff",
    //             border: "1px solid #ccc",
    //             borderRadius: "6px",
    //             height: 38,
    //             width: 130,
    //             px: 1.2,
    //             boxShadow: "0px 1px 3px rgba(0, 0, 0, 0.05)",
    //             overflow: "hidden",
    //           }}
    //         >
    //           <CalendarTodayIcon sx={{ color: "#A0A4A8", fontSize: 16, mr: 1 }} />

    //           <DatePicker
    //             selected={filters.date}
    //             onChange={handleDateChange}
    //             dateFormat="yy-MM-dd"
    //             placeholderText="Date"
    //             isClearable
    //             popperPlacement="bottom-start"
    //             customInput={
    //               <input
    //                 style={{
    //                   border: "none",
    //                   outline: "none",
    //                   width: "60px",
    //                   height: "100%",
    //                   background: "transparent",
    //                   fontSize: "13px",
    //                   color: "#7f8c8d",
    //                 }}
    //               />
    //             }
    //           />
    //         </Box>







    //         <FilterActions
    //           sx={{
    //             display: 'flex',
    //             alignItems: 'center',
    //             gap: 1,
    //             flexWrap: 'nowrap',
    //           }}
    //         >
    //           <Button
    //             variant="contained"
    //             color="success"
    //             onClick={applyFilters}
    //             disabled={loading}
    //             size="small"
    //             startIcon={<FontAwesomeIcon icon={faCheck} />}
    //           >
    //             Apply
    //           </Button>
    //           <Button
    //             variant="contained"
    //             color="error"
    //             onClick={clearFilters}
    //             disabled={loading}
    //             size="small"
    //             startIcon={<FontAwesomeIcon icon={faTimes} />}
    //           >
    //             Clear
    //           </Button>
    //         </FilterActions>

    //       </FiltersContainer>
    //     </Box>



    //     {/* /////////////////////////////////////////////////////////////////////////////////////////////////////// */}





    //     {/* Loading/Error/No Data State */}
    //     {loading ? (
    //       <LoadingContainer>
    //         <CircularProgress size={48} color="primary" />
    //         <Typography variant="body2" sx={{ mt: 2 }}>
    //           Loading timesheets...
    //         </Typography>
    //       </LoadingContainer>
    //     ) : error ? (
    //       <ErrorContainer>
    //         <FontAwesomeIcon icon={faExclamationCircle} size="2x" style={{ marginBottom: 12 }} />
    //         <Typography variant="body2" sx={{ mb: 2 }}>{error}</Typography>
    //         <Button variant="contained" color="primary" onClick={handleRetry} size="small" startIcon={<FontAwesomeIcon icon={faSyncAlt} />}>Retry</Button>
    //       </ErrorContainer>
    //     ) : (
    //       <>
    //         {timesheets.length === 0 ? (
    //           <NoResultsContainer>
    //             <img src="/images/no-data.svg" alt="No results" style={{ maxWidth: 160, marginBottom: 20, opacity: 0.6 }} />
    //             <Typography variant="body2" gutterBottom>No timesheets found</Typography>
    //             <Typography variant="caption" color="text.secondary" gutterBottom>
    //               Try adjusting your filters or check back later
    //             </Typography>
    //             {(filters.employeeId || filters.date) && (
    //               <Button variant="outlined" onClick={clearFilters} sx={{ mt: 1 }} size="small">Clear filters</Button>
    //             )}
    //           </NoResultsContainer>
    //         ) : (
    //           <Box sx={{ mt: 2 }}>


    //             {/* ✅ Web View (No changes to your original layout) */}
    //             <Box sx={{ display: { xs: "none", sm: "block" } }}>
    //               <Grid container spacing={3} sx={{ mt: 1, mb: 1 }}>
    //                 {[
    //                   {
    //                     label: "Total Entries",
    //                     value: allDataTotals.entries,
    //                     iconColor: "#2563eb",
    //                     bgColor: "#e0edff",
    //                     Icon: FormatListNumberedIcon,
    //                   },
    //                   {
    //                     label: "Page Hours",
    //                     value: currentPageTotals.hours,
    //                     iconColor: "#16a34a",
    //                     bgColor: "#d1fae5",
    //                     Icon: AccessTimeIcon,
    //                   },
    //                   {
    //                     label: "Page Members",
    //                     value: currentPageTotals.members,
    //                     iconColor: "#b45309",
    //                     bgColor: "#fef3c7",
    //                     Icon: PeopleAltIcon,
    //                   },
    //                 ].map((item, index) => (
    //                   <Grid item xs={12} sm={4} key={index}>
    //                     <Card
    //                       sx={{
    //                         borderRadius: 3,
    //                         p: 2.5,
    //                         display: "flex",
    //                         justifyContent: "space-between",
    //                         alignItems: "center",
    //                         boxShadow: "0 2px 8px rgba(0,0,0,0.04)",
    //                       }}
    //                     >
    //                       {/* Left Side */}
    //                       <Box>
    //                         <Typography sx={{ fontSize: 14, fontWeight: 500, color: "#374151", mb: 0.8 }}>
    //                           {item.label}
    //                         </Typography>
    //                         <Typography sx={{ fontSize: 22, fontWeight: "bold", color: "#000" }}>
    //                           {item.value}
    //                         </Typography>
    //                       </Box>

    //                       {/* Right Side Icon */}
    //                       <Box
    //                         sx={{
    //                           backgroundColor: item.bgColor,
    //                           borderRadius: 2,
    //                           p: 1.5,
    //                           display: "flex",
    //                           alignItems: "center",
    //                           justifyContent: "center",
    //                         }}
    //                       >
    //                         <item.Icon sx={{ color: item.iconColor, fontSize: 22 }} />
    //                       </Box>
    //                     </Card>
    //                   </Grid>
    //                 ))}
    //               </Grid>
    //             </Box>

    //             {/* 📱 Mobile View (All 3 cards in one row with horizontal scroll) */}
    //             <Box
    //               sx={{
    //                 display: { xs: "flex", sm: "none" },
    //                 overflowX: "auto",
    //                 gap: 1.3, // smaller gap for more space
    //                 p: 1.5,
    //                 pb: 2,
    //                 scrollSnapType: "x mandatory",
    //               }}
    //             >
    //               {[
    //                 {
    //                   label: "Total Entries",
    //                   value: allDataTotals.entries,
    //                   iconColor: "#2563eb",
    //                   bgColor: "#e0edff",
    //                   Icon: FormatListNumberedIcon,
    //                 },
    //                 {
    //                   label: "Page Hours",
    //                   value: currentPageTotals.hours,
    //                   iconColor: "#16a34a",
    //                   bgColor: "#d1fae5",
    //                   Icon: AccessTimeIcon,
    //                 },
    //                 {
    //                   label: "Page Members",
    //                   value: currentPageTotals.members,
    //                   iconColor: "#b45309",
    //                   bgColor: "#fef3c7",
    //                   Icon: PeopleAltIcon,
    //                 },
    //               ].map((item, index) => (
    //                 <Card
    //                   key={index}
    //                   sx={{
    //                     minWidth: 129, // reduced width for mobile
    //                     borderRadius: 2,
    //                     p: 1, // smaller padding so content fits
    //                     flexShrink: 0,
    //                     display: "flex",
    //                     justifyContent: "space-between",
    //                     alignItems: "center",
    //                     boxShadow: "0 2px 8px rgba(0,0,0,0.06)",
    //                     scrollSnapAlign: "start",
    //                   }}
    //                 >
    //                   {/* Left Side */}
    //                   <Box>
    //                     <Typography
    //                       sx={{
    //                         fontSize: 12,
    //                         fontWeight: 500,
    //                         color: "#374151",
    //                         mb: 0.5,
    //                       }}
    //                     >
    //                       {item.label}
    //                     </Typography>
    //                     <Typography
    //                       sx={{
    //                         fontSize: 18,
    //                         fontWeight: "bold",
    //                         color: "#000",
    //                       }}
    //                     >
    //                       {item.value}
    //                     </Typography>
    //                   </Box>

    //                   {/* Right Side Icon */}
    //                   <Box
    //                     sx={{
    //                       backgroundColor: item.bgColor,
    //                       borderRadius: 2,
    //                       p: 0.7,
    //                       display: "flex",
    //                       alignItems: "center",
    //                       justifyContent: "center",
    //                     }}
    //                   >
    //                     <item.Icon sx={{ color: item.iconColor, fontSize: 18 }} />
    //                   </Box>
    //                 </Card>
    //               ))}
    //             </Box>







    //             <Box
    //               sx={{
    //                 backgroundColor: "#f4f6f8",
    //                 minHeight: "100vh",
    //                 py: 4,
    //                 px: 0, // ✅ Removed left-right padding to avoid compression
    //               }}
    //             >
    //               <Box
    //                 sx={{
    //                   maxWidth: "100%",
    //                   width: "100%",
    //                   mx: "auto",
    //                   backgroundColor: "#fff",
    //                   borderRadius: 2,
    //                   px: { xs: 2, sm: 3 },
    //                   py: 3,
    //                   boxShadow: "none",         // ✅ Remove any shadow
    //                   border: "none !important", // ✅ Force remove border
    //                 }}
    //               >

    //                 <Typography variant="h6" fontWeight={600} gutterBottom fontSize={18}>
    //                   Timesheet Records
    //                 </Typography>
    //                 <Typography variant="body2" color="text.secondary" gutterBottom fontSize={14}>
    //                   Review and manage employee timesheets
    //                 </Typography>


    //                 {/* ✅ Desktop Table View (Hidden on xs) */}
    //                 <Box sx={{ overflowX: "auto", display: { xs: "none", sm: "block" } }}>
    //                   <Table
    //                     sx={{
    //                       minWidth: 650,
    //                       borderCollapse: "collapse",
    //                       border: "none !important",
    //                       outline: "none !important",
    //                       "& td, & th": {
    //                         border: "none !important",
    //                       },
    //                     }}
    //                   >
    //                     <TableHead>
    //                       <TableRow
    //                         sx={{
    //                           backgroundColor: "#f9f9f9",
    //                           "& th": {
    //                             borderBottom: "1px solid #e0e0e0",
    //                           },
    //                         }}
    //                       >
    //                         <TableCell sx={{ fontWeight: 500, fontSize: 15 }}>
    //                           <FontAwesomeIcon icon={faCalendarAlt} /> Date
    //                         </TableCell>
    //                         <TableCell sx={{ fontWeight: 500, fontSize: 15 }}>
    //                           <FontAwesomeIcon icon={faUser} /> Employee
    //                         </TableCell>
    //                         <TableCell sx={{ fontWeight: 500, fontSize: 15 }}>
    //                           <FontAwesomeIcon icon={faEnvelope} /> Email
    //                         </TableCell>
    //                         <TableCell sx={{ fontWeight: 500, fontSize: 15 }}>
    //                           <FontAwesomeIcon icon={faTasks} /> Tasks
    //                         </TableCell>
    //                       </TableRow>
    //                     </TableHead>

    //                     <TableBody>
    //                       {timesheets.map((timesheet) => (
    //                         <TableRow key={timesheet._id} hover sx={{ "& td": { borderBottom: "none" } }}>
    //                           <TableCell sx={{ fontSize: 14 }}>
    //                             <Typography variant="body2" fontWeight={500} fontSize={14}>
    //                               {formatDate(timesheet.date)}
    //                             </Typography>
    //                           </TableCell>

    //                           <TableCell>
    //                             <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
    //                               <Avatar
    //                                 sx={{
    //                                   width: 30,
    //                                   height: 30,
    //                                   fontSize: "0.9rem",
    //                                   bgcolor: "primary.main",
    //                                 }}
    //                               >
    //                                 {timesheet.userId?.name?.charAt(0) || "U"}
    //                               </Avatar>
    //                               <Box>
    //                                 <Typography fontSize={14} fontWeight={500}>
    //                                   {timesheet.userId?.name || "N/A"}
    //                                 </Typography>
    //                                 <Typography fontSize={12} color="text.secondary">
    //                                   {timesheet.userId?.position || "Team Member"}
    //                                 </Typography>
    //                               </Box>
    //                             </Box>
    //                           </TableCell>

    //                           <TableCell>
    //                             <Link
    //                               href={`mailto:${timesheet.userId?.email || ""}`}
    //                               color="primary"
    //                               fontSize={14}
    //                               underline="hover"
    //                               sx={{ wordBreak: "break-all" }}
    //                             >
    //                               {timesheet.userId?.email || "N/A"}
    //                             </Link>
    //                           </TableCell>

    //                           <TableCell>
    //                             <Box>
    //                               {timesheet.taskDetails.map((task, index) => (
    //                                 <Box
    //                                   key={index}
    //                                   sx={{
    //                                     display: "flex",
    //                                     justifyContent: "space-between",
    //                                     alignItems: "flex-start",
    //                                     gap: 1,
    //                                     mb: 0.5,
    //                                   }}
    //                                 >
    //                                   <Typography
    //                                     fontSize={14}
    //                                     sx={{
    //                                       wordBreak: "break-word",
    //                                       whiteSpace: "pre-wrap",
    //                                       maxWidth: { xs: "150px", sm: "300px" },
    //                                       flex: 1,
    //                                     }}
    //                                   >
    //                                     {task.taskName}
    //                                   </Typography>

    //                                   <Typography
    //                                     fontSize={13}
    //                                     color="text.secondary"
    //                                     fontWeight={500}
    //                                     sx={{ whiteSpace: "nowrap" }}
    //                                   >
    //                                     {task.duration} hrs
    //                                   </Typography>
    //                                 </Box>
    //                               ))}
    //                             </Box>
    //                           </TableCell>
    //                         </TableRow>
    //                       ))}
    //                     </TableBody>
    //                   </Table>
    //                 </Box>

    //                 {/* ✅ Mobile Card View (Visible only on xs) */}
    //                 <Box sx={{ display: { xs: "block", sm: "none" } }}>
    //                   {timesheets.map((timesheet) => (
    //                     <Box
    //                       key={timesheet._id}
    //                       sx={{
    //                         backgroundColor: "#fff",
    //                         borderRadius: 2,
    //                         p: 2,
    //                         mb: 2,
    //                         boxShadow: "0 2px 6px rgba(0,0,0,0.08)",
    //                         display: "flex",
    //                         flexDirection: "column",
    //                         gap: 1.5,
    //                       }}
    //                     >
    //                       {/* Date */}
    //                       <Typography
    //                         fontWeight={600}
    //                         fontSize={15}
    //                         sx={{ display: "flex", alignItems: "center", gap: 1, color: "text.secondary" }}
    //                       >
    //                         <FontAwesomeIcon icon={faCalendarAlt} /> {formatDate(timesheet.date)}
    //                       </Typography>

    //                       {/* Row with Avatar + Name + Position on left & Email on right */}
    //                       <Box
    //                         sx={{
    //                           display: "flex",
    //                           justifyContent: "space-between",
    //                           alignItems: "center",
    //                           flexWrap: "wrap",
    //                           gap: 1,
    //                         }}
    //                       >
    //                         {/* Left: Avatar + Name & Position */}
    //                         <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
    //                           <Avatar
    //                             sx={{
    //                               width: 36,
    //                               height: 36,
    //                               fontSize: "0.95rem",
    //                               bgcolor: "primary.main",
    //                             }}
    //                           >
    //                             {timesheet.userId?.name?.charAt(0) || "U"}
    //                           </Avatar>
    //                           <Box sx={{ display: "flex", flexDirection: "column", gap: 0.2 }}>
    //                             <Typography fontSize={14} fontWeight={600}>
    //                               {timesheet.userId?.name || "N/A"}
    //                             </Typography>
    //                             <Typography fontSize={12} color="text.secondary">
    //                               {timesheet.userId?.position || "Team Member"}
    //                             </Typography>
    //                           </Box>
    //                         </Box>

    //                         {/* Right: Email */}
    //                         <Link
    //                           href={`mailto:${timesheet.userId?.email || ""}`}
    //                           color="primary"
    //                           fontSize={13}
    //                           underline="hover"
    //                           sx={{
    //                             display: "flex",
    //                             alignItems: "center",
    //                             gap: 0.5,
    //                             wordBreak: "break-all",
    //                             maxWidth: "150px",
    //                             textAlign: "right",
    //                           }}
    //                         >
    //                           <FontAwesomeIcon icon={faEnvelope} /> {timesheet.userId?.email || "N/A"}
    //                         </Link>
    //                       </Box>

    //                       {/* Tasks */}
    //                       <Box>
    //                         <Typography
    //                           fontWeight={600}
    //                           fontSize={14}
    //                           sx={{ display: "flex", alignItems: "center", gap: 1, mb: 0.5 }}
    //                         >
    //                           <FontAwesomeIcon icon={faTasks} /> Tasks
    //                         </Typography>
    //                         {timesheet.taskDetails.map((task, index) => (
    //                           <Box
    //                             key={index}
    //                             sx={{
    //                               display: "flex",
    //                               justifyContent: "space-between",
    //                               alignItems: "flex-start",
    //                               gap: 1,
    //                               p: 1,
    //                               backgroundColor: "#f9f9f9",
    //                               borderRadius: 1,
    //                               mb: 0.5,
    //                             }}
    //                           >
    //                             <Typography
    //                               fontSize={13}
    //                               sx={{ wordBreak: "break-word", whiteSpace: "pre-wrap", flex: 1 }}
    //                             >
    //                               {task.taskName}
    //                             </Typography>
    //                             <Typography
    //                               fontSize={12}
    //                               color="text.secondary"
    //                               fontWeight={500}
    //                               sx={{ whiteSpace: "nowrap" }}
    //                             >
    //                               {task.duration} hrs
    //                             </Typography>
    //                           </Box>
    //                         ))}
    //                       </Box>
    //                     </Box>
    //                   ))}
    //                 </Box>



    //                 {/* Pagination Controls */}
    //                 <Box
    //                   sx={{
    //                     display: "flex",
    //                     flexDirection: { xs: "column", sm: "row" },
    //                     justifyContent: "space-between",
    //                     alignItems: "center",
    //                     gap: { xs: 1.5, sm: 2 },
    //                     mt: 3,
    //                   }}
    //                 >
    //                   <Button
    //                     onClick={() => handlePageChange(pagination.currentPage - 1)}
    //                     disabled={!pagination.hasPreviousPage || loading}
    //                     variant="outlined"
    //                     size="small"
    //                     startIcon={<FontAwesomeIcon icon={faChevronLeft} />}
    //                     sx={{ borderRadius: 2 }}
    //                   >
    //                     Previous
    //                   </Button>

    //                   <Typography
    //                     variant="body2"
    //                     fontSize={13}
    //                     sx={{
    //                       textAlign: "center",
    //                       alignSelf: { xs: "auto", sm: "center" },
    //                       whiteSpace: "nowrap", // ⬅️ Keeps text in one line
    //                     }}
    //                   >
    //                     Page {pagination.currentPage} of {pagination.totalPages}
    //                   </Typography>

    //                   <Button
    //                     onClick={() => handlePageChange(pagination.currentPage + 1)}
    //                     disabled={!pagination.hasNextPage || loading}
    //                     variant="outlined"
    //                     size="small"
    //                     endIcon={<FontAwesomeIcon icon={faChevronRight} />}
    //                     sx={{ borderRadius: 2 }}
    //                   >
    //                     Next
    //                   </Button>
    //                 </Box>

    //               </Box>

    //             </Box>




    //           </Box>
    //         )}
    //       </>
    //     )}
    //   </TimesheetContainer>

    //   <Footer />
    // </Box>



    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        minHeight: "100vh",
        bgcolor: "#f5f7fa",
      }}
    >

      <Navbar toggleSidebar={toggleSidebar} />
      <Sidebar isOpen={isSidebarOpen} toggleSidebar={toggleSidebar} />
<Box
  sx={{
    p: {xs:1.5,md:3},
    ml: { xs: 0, md: '240px' }, // 0 margin on mobile, 240px on medium+ screens
  }}
>



        <Box sx={{ mt: 6, mb: 1 }}>
          <Typography variant="h4" fontWeight="bold" gutterBottom>
            <FontAwesomeIcon icon={faClock} /> Timesheet Access
          </Typography>
          <Typography variant="subtitle1" color="text.secondary">
            Review and manage your team&apos;s timesheet entries
          </Typography>
        </Box>

        <TimesheetFiltersBar elevation={0}>
          <TimesheetFiltersGrid>
            <TimesheetEmployeeFilterField>
              <TimesheetFilterLabel>Employee</TimesheetFilterLabel>
              <TimesheetFilterControl>
                <FontAwesomeIcon
                  icon={faFilter}
                  style={{ color: "#94a3b8", fontSize: 14, flexShrink: 0 }}
                />
                <Select
                  id="employeeId"
                  name="employeeId"
                  value={filters.employeeId}
                  onChange={handleFilterChange}
                  displayEmpty
                  fullWidth
                  variant="standard"
                  disableUnderline
                  size="small"
                  MenuProps={{
                    PaperProps: {
                      sx: { borderRadius: 2, mt: 0.5, maxHeight: 320 },
                    },
                  }}
                  sx={{
                    fontSize: "0.875rem",
                    color: "#1a1a2e",
                    "& .MuiSelect-select": {
                      py: 0,
                      display: "flex",
                      alignItems: "center",
                    },
                  }}
                  renderValue={(selected) => {
                    if (!selected) {
                      return (
                        <Typography sx={{ color: "#94a3b8", fontSize: "0.875rem" }}>
                          All employees
                        </Typography>
                      );
                    }
                    const emp = employees.find((e) => e.employeeid === selected);
                    return emp
                      ? `${emp.name} (${emp.employeeid})`
                      : selected;
                  }}
                >
                  <MenuItem value="">
                    <em>All employees</em>
                  </MenuItem>
                  {employees.map((employee) => (
                    <MenuItem key={employee._id} value={employee.employeeid}>
                      {employee.name} ({employee.employeeid})
                    </MenuItem>
                  ))}
                </Select>
              </TimesheetFilterControl>
            </TimesheetEmployeeFilterField>

            <TimesheetDateFilterField>
              <TimesheetFilterLabel>Date</TimesheetFilterLabel>
              <TimesheetDateFilterControl className="timesheet-date-filter-box">
                <CalendarTodayIcon
                  sx={{ color: "#94a3b8", fontSize: 18, flexShrink: 0 }}
                />
                <DatePicker
                  selected={filters.date}
                  onChange={handleDateChange}
                  dateFormat="dd MMM yyyy"
                  placeholderText="Select date"
                  isClearable
                  popperPlacement="bottom-start"
                  popperClassName="timesheet-datepicker-popper"
                  calendarClassName="timesheet-datepicker-calendar"
                  popperProps={{ strategy: "fixed" }}
                  wrapperClassName="timesheet-date-filter-wrapper"
                  className="timesheet-date-filter-input"
                />
              </TimesheetDateFilterControl>
            </TimesheetDateFilterField>

            <TimesheetFilterActionsSlot>
              <Button
                variant="contained"
                onClick={applyFilters}
                disabled={loading}
                startIcon={<FontAwesomeIcon icon={faCheck} />}
                sx={{
                  height: 40,
                  minWidth: 100,
                  borderRadius: "10px",
                  textTransform: "none",
                  fontWeight: 600,
                  fontSize: "0.875rem",
                  background: "linear-gradient(135deg, #667eea, #764ba2)",
                  boxShadow: "0 4px 12px rgba(102, 126, 234, 0.25)",
                  "&:hover": {
                    background: "linear-gradient(135deg, #5a6fd6, #6a4296)",
                  },
                }}
              >
                Apply
              </Button>
              <Button
                variant="outlined"
                onClick={clearFilters}
                disabled={loading}
                startIcon={<FontAwesomeIcon icon={faTimes} />}
                sx={{
                  height: 40,
                  minWidth: 100,
                  borderRadius: "10px",
                  textTransform: "none",
                  fontWeight: 600,
                  fontSize: "0.875rem",
                  color: "#64748b",
                  borderColor: "#e2e8f0",
                  "&:hover": {
                    borderColor: "#cbd5e1",
                    bgcolor: "#f8fafc",
                  },
                }}
              >
                Clear
              </Button>
            </TimesheetFilterActionsSlot>
          </TimesheetFiltersGrid>
        </TimesheetFiltersBar>



        {/* /////////////////////////////////////////////////////////////////////////////////////////////////////// */}





        {/* Loading/Error/No Data State */}
        {loading ? (
          <LoadingContainer>
            <CircularProgress size={48} color="primary" />
            <Typography variant="body2" sx={{ mt: 2 }}>
              Loading timesheets...
            </Typography>
          </LoadingContainer>
        ) : error ? (
          <ErrorContainer>
            <FontAwesomeIcon icon={faExclamationCircle} size="2x" style={{ marginBottom: 12 }} />
            <Typography variant="body2" sx={{ mb: 2 }}>{error}</Typography>
            <Button variant="contained" color="primary" onClick={handleRetry} size="small" startIcon={<FontAwesomeIcon icon={faSyncAlt} />}>Retry</Button>
          </ErrorContainer>
        ) : (
          <>
            {timesheets.length === 0 ? (
              <NoResultsContainer>
                <img src="/images/no-data.svg" alt="No results" style={{ maxWidth: 160, marginBottom: 20, opacity: 0.6 }} />
                <Typography variant="body2" gutterBottom>
                  {filters.date
                    ? `No records found for ${filters.date.toLocaleDateString("en-US", {
                        day: "numeric",
                        month: "short",
                        year: "numeric",
                      })}`
                    : "No timesheets found"}
                </Typography>
                <Typography variant="caption" color="text.secondary" gutterBottom>
                  {filters.date || filters.employeeId
                    ? "Try a different date or employee filter"
                    : "Try adjusting your filters or check back later"}
                </Typography>
                {(filters.employeeId || filters.date) && (
                  <Button variant="outlined" onClick={clearFilters} sx={{ mt: 1 }} size="small">Clear filters</Button>
                )}
              </NoResultsContainer>
            ) : (
              <Box sx={{ mt: 2 }}>


                {/* ✅ Web View (No changes to your original layout) */}
                <Box sx={{ display: { xs: "none", sm: "block" } }}>
                  <Grid container spacing={3} sx={{ mt: 1, mb: 1 }}>
                    {[
                      {
                        label: "Total Entries",
                        value: allDataTotals.entries,
                        iconColor: "#2563eb",
                        bgColor: "#e0edff",
                        Icon: FormatListNumberedIcon,
                      },
                      {
                        label: "Page Hours",
                        value: currentPageTotals.hours,
                        iconColor: "#16a34a",
                        bgColor: "#d1fae5",
                        Icon: AccessTimeIcon,
                      },
                      {
                        label: "Page Members",
                        value: currentPageTotals.members,
                        iconColor: "#b45309",
                        bgColor: "#fef3c7",
                        Icon: PeopleAltIcon,
                      },
                    ].map((item, index) => (
                      <Grid item xs={12} sm={4} key={index}>
                        <Card
                          sx={{
                            borderRadius: 3,
                            p: 2.5,
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                            boxShadow: "0 2px 8px rgba(0,0,0,0.04)",
                          }}
                        >
                          {/* Left Side */}
                          <Box>
                            <Typography sx={{ fontSize: 14, fontWeight: 500, color: "#374151", mb: 0.8 }}>
                              {item.label}
                            </Typography>
                            <Typography sx={{ fontSize: 22, fontWeight: "bold", color: "#000" }}>
                              {item.value}
                            </Typography>
                          </Box>

                          {/* Right Side Icon */}
                          <Box
                            sx={{
                              backgroundColor: item.bgColor,
                              borderRadius: 2,
                              p: 1.5,
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                            }}
                          >
                            <item.Icon sx={{ color: item.iconColor, fontSize: 22 }} />
                          </Box>
                        </Card>
                      </Grid>
                    ))}
                  </Grid>
                </Box>

                {/* 📱 Mobile View (All 3 cards in one row with horizontal scroll) */}
                <Box
                  sx={{
                    display: { xs: "flex", sm: "none" },
                    overflowX: "auto",
                    gap: 1.3, // smaller gap for more space
                    p: 1.5,
                    pb: 2,
                    scrollSnapType: "x mandatory",
                  }}
                >
                  {[
                    {
                      label: "Total Entries",
                      value: allDataTotals.entries,
                      iconColor: "#2563eb",
                      bgColor: "#e0edff",
                      Icon: FormatListNumberedIcon,
                    },
                    {
                      label: "Page Hours",
                      value: currentPageTotals.hours,
                      iconColor: "#16a34a",
                      bgColor: "#d1fae5",
                      Icon: AccessTimeIcon,
                    },
                    {
                      label: "Page Members",
                      value: currentPageTotals.members,
                      iconColor: "#b45309",
                      bgColor: "#fef3c7",
                      Icon: PeopleAltIcon,
                    },
                  ].map((item, index) => (
                    <Card
                      key={index}
                      sx={{
                        minWidth: 129, // reduced width for mobile
                        borderRadius: 2,
                        p: 1, // smaller padding so content fits
                        flexShrink: 0,
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        boxShadow: "0 2px 8px rgba(0,0,0,0.06)",
                        scrollSnapAlign: "start",
                      }}
                    >
                      {/* Left Side */}
                      <Box>
                        <Typography
                          sx={{
                            fontSize: 12,
                            fontWeight: 500,
                            color: "#374151",
                            mb: 0.5,
                          }}
                        >
                          {item.label}
                        </Typography>
                        <Typography
                          sx={{
                            fontSize: 18,
                            fontWeight: "bold",
                            color: "#000",
                          }}
                        >
                          {item.value}
                        </Typography>
                      </Box>

                      {/* Right Side Icon */}
                      <Box
                        sx={{
                          backgroundColor: item.bgColor,
                          borderRadius: 2,
                          p: 0.7,
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                        }}
                      >
                        <item.Icon sx={{ color: item.iconColor, fontSize: 18 }} />
                      </Box>
                    </Card>
                  ))}
                </Box>







                <Box
                  sx={{
                    backgroundColor: "#f4f6f8",
                    minHeight: "100vh",
                    py: 4,
                    px: 0, // ✅ Removed left-right padding to avoid compression
                  }}
                >
                  <Box
                    sx={{
                      maxWidth: "100%",
                      width: "100%",
                      mx: "auto",
                      backgroundColor: "#fff",
                      borderRadius: 2,
                      px: { xs: 2, sm: 3 },
                      py: 3,
                      boxShadow: "none",         // ✅ Remove any shadow
                      border: "none !important", // ✅ Force remove border
                    }}
                  >

                    <Typography variant="h6" fontWeight={600} gutterBottom fontSize={18}>
                      Timesheet Records
                    </Typography>
                    <Typography variant="body2" color="text.secondary" gutterBottom fontSize={14}>
                      Review and manage employee timesheets
                    </Typography>


                    {/* ✅ Desktop Table View (Hidden on xs) */}
                    <Box sx={{ overflowX: "auto", display: { xs: "none", sm: "block" } }}>
                      <Table
                        sx={{
                          minWidth: 650,
                          borderCollapse: "collapse",
                          border: "none !important",
                          outline: "none !important",
                          "& td, & th": {
                            border: "none !important",
                          },
                        }}
                      >
                        <TableHead>
                          <TableRow
                            sx={{
                              backgroundColor: "#f9f9f9",
                              "& th": {
                                borderBottom: "1px solid #e0e0e0",
                              },
                            }}
                          >
                            <TableCell sx={{ fontWeight: 500, fontSize: 15 }}>
                              <FontAwesomeIcon icon={faCalendarAlt} /> Date
                            </TableCell>
                            <TableCell sx={{ fontWeight: 500, fontSize: 15 }}>
                              <FontAwesomeIcon icon={faUser} /> Employee
                            </TableCell>
                            <TableCell sx={{ fontWeight: 500, fontSize: 15 }}>
                              <FontAwesomeIcon icon={faEnvelope} /> Email
                            </TableCell>
                            <TableCell sx={{ fontWeight: 500, fontSize: 15 }}>
                              <FontAwesomeIcon icon={faTasks} /> Tasks
                            </TableCell>
                          </TableRow>
                        </TableHead>

                        <TableBody>
                          {timesheets.map((timesheet) => (
                            <TableRow key={timesheet._id} hover sx={{ "& td": { borderBottom: "none" } }}>
                              <TableCell sx={{ fontSize: 14 }}>
                                <Typography variant="body2" fontWeight={500} fontSize={14}>
                                  {formatDate(timesheet.date)}
                                </Typography>
                              </TableCell>

                              <TableCell>
                                <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                                  <Avatar
                                    sx={{
                                      width: 30,
                                      height: 30,
                                      fontSize: "0.9rem",
                                      bgcolor: "primary.main",
                                    }}
                                  >
                                    {timesheet.userId?.name?.charAt(0) || "U"}
                                  </Avatar>
                                  <Box>
                                    <Typography fontSize={14} fontWeight={500}>
                                      {timesheet.userId?.name || "N/A"}
                                    </Typography>
                                    <Typography fontSize={12} color="text.secondary">
                                      {timesheet.userId?.position || "Team Member"}
                                    </Typography>
                                  </Box>
                                </Box>
                              </TableCell>

                              <TableCell>
                                <Link
                                  href={`mailto:${timesheet.userId?.email || ""}`}
                                  color="primary"
                                  fontSize={14}
                                  underline="hover"
                                  sx={{ wordBreak: "break-all" }}
                                >
                                  {timesheet.userId?.email || "N/A"}
                                </Link>
                              </TableCell>

                              <TableCell>
                                <Box>
                                  {timesheet.taskDetails.map((task, index) => (
                                    <Box
                                      key={index}
                                      sx={{
                                        display: "flex",
                                        justifyContent: "space-between",
                                        alignItems: "flex-start",
                                        gap: 1,
                                        mb: 0.5,
                                      }}
                                    >
                                      <Typography
                                        fontSize={14}
                                        sx={{
                                          wordBreak: "break-word",
                                          whiteSpace: "pre-wrap",
                                          maxWidth: { xs: "150px", sm: "300px" },
                                          flex: 1,
                                        }}
                                      >
                                        {task.taskName}
                                      </Typography>

                                      <Typography
                                        fontSize={13}
                                        color="text.secondary"
                                        fontWeight={500}
                                        sx={{ whiteSpace: "nowrap" }}
                                      >
                                        {task.duration} hrs
                                      </Typography>
                                    </Box>
                                  ))}
                                </Box>
                              </TableCell>
                            </TableRow>
                          ))}
                        </TableBody>
                      </Table>
                    </Box>

                    {/* ✅ Mobile Card View (Visible only on xs) */}
                    <Box sx={{ display: { xs: "block", sm: "none" } }}>
                      {timesheets.map((timesheet) => (
                        <Box
                          key={timesheet._id}
                          sx={{
                            backgroundColor: "#fff",
                            borderRadius: 2,
                            p: 2,
                            mb: 2,
                            boxShadow: "0 2px 6px rgba(0,0,0,0.08)",
                            display: "flex",
                            flexDirection: "column",
                            gap: 1.5,
                          }}
                        >
                          {/* Date */}
                          <Typography
                            fontWeight={600}
                            fontSize={15}
                            sx={{ display: "flex", alignItems: "center", gap: 1, color: "text.secondary" }}
                          >
                            <FontAwesomeIcon icon={faCalendarAlt} /> {formatDate(timesheet.date)}
                          </Typography>

                          {/* Row with Avatar + Name + Position on left & Email on right */}
                          <Box
                            sx={{
                              display: "flex",
                              justifyContent: "space-between",
                              alignItems: "center",
                              flexWrap: "wrap",
                              gap: 1,
                            }}
                          >
                            {/* Left: Avatar + Name & Position */}
                            <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                              <Avatar
                                sx={{
                                  width: 36,
                                  height: 36,
                                  fontSize: "0.95rem",
                                  bgcolor: "primary.main",
                                }}
                              >
                                {timesheet.userId?.name?.charAt(0) || "U"}
                              </Avatar>
                              <Box sx={{ display: "flex", flexDirection: "column", gap: 0.2 }}>
                                <Typography fontSize={14} fontWeight={600}>
                                  {timesheet.userId?.name || "N/A"}
                                </Typography>
                                <Typography fontSize={12} color="text.secondary">
                                  {timesheet.userId?.position || "Team Member"}
                                </Typography>
                              </Box>
                            </Box>

                            {/* Right: Email */}
                            <Link
                              href={`mailto:${timesheet.userId?.email || ""}`}
                              color="primary"
                              fontSize={13}
                              underline="hover"
                              sx={{
                                display: "flex",
                                alignItems: "center",
                                gap: 0.5,
                                wordBreak: "break-all",
                                maxWidth: "150px",
                                textAlign: "right",
                              }}
                            >
                              <FontAwesomeIcon icon={faEnvelope} /> {timesheet.userId?.email || "N/A"}
                            </Link>
                          </Box>

                          {/* Tasks */}
                          <Box>
                            <Typography
                              fontWeight={600}
                              fontSize={14}
                              sx={{ display: "flex", alignItems: "center", gap: 1, mb: 0.5 }}
                            >
                              <FontAwesomeIcon icon={faTasks} /> Tasks
                            </Typography>
                            {timesheet.taskDetails.map((task, index) => (
                              <Box
                                key={index}
                                sx={{
                                  display: "flex",
                                  justifyContent: "space-between",
                                  alignItems: "flex-start",
                                  gap: 1,
                                  p: 1,
                                  backgroundColor: "#f9f9f9",
                                  borderRadius: 1,
                                  mb: 0.5,
                                }}
                              >
                                <Typography
                                  fontSize={13}
                                  sx={{ wordBreak: "break-word", whiteSpace: "pre-wrap", flex: 1 }}
                                >
                                  {task.taskName}
                                </Typography>
                                <Typography
                                  fontSize={12}
                                  color="text.secondary"
                                  fontWeight={500}
                                  sx={{ whiteSpace: "nowrap" }}
                                >
                                  {task.duration} hrs
                                </Typography>
                              </Box>
                            ))}
                          </Box>
                        </Box>
                      ))}
                    </Box>



                    {/* Pagination Controls */}
                    <Box
                      sx={{
                        display: "flex",
                        flexDirection: { xs: "column", sm: "row" },
                        justifyContent: "space-between",
                        alignItems: "center",
                        gap: { xs: 1.5, sm: 2 },
                        mt: 3,
                      }}
                    >
                      <Button
                        onClick={() => handlePageChange(pagination.currentPage - 1)}
                        disabled={!pagination.hasPreviousPage || loading}
                        variant="outlined"
                        size="small"
                        startIcon={<FontAwesomeIcon icon={faChevronLeft} />}
                        sx={{ borderRadius: 2 }}
                      >
                        Previous
                      </Button>

                      <Typography
                        variant="body2"
                        fontSize={13}
                        sx={{
                          textAlign: "center",
                          alignSelf: { xs: "auto", sm: "center" },
                          whiteSpace: "nowrap", // ⬅️ Keeps text in one line
                        }}
                      >
                        Page {pagination.currentPage} of {pagination.totalPages}
                      </Typography>

                      <Button
                        onClick={() => handlePageChange(pagination.currentPage + 1)}
                        disabled={!pagination.hasNextPage || loading}
                        variant="outlined"
                        size="small"
                        endIcon={<FontAwesomeIcon icon={faChevronRight} />}
                        sx={{ borderRadius: 2 }}
                      >
                        Next
                      </Button>
                    </Box>

                  </Box>

                </Box>




              </Box>
            )}
          </>
        )}
      </Box>

      <Footer />
    </Box>

  );
};

export default TimesheetAccess;